<template>
  <div class="modal-out">
    <div class="modal" style="width: 500px;">

      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="min-height: auto">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <div>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="名称" required prop="name">
                  <el-input v-model="addForm.name" placeholder="输入名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="设备号" required prop="deviceId">
                  <el-input v-model="addForm.deviceId" placeholder="输入设备号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </div>

        </el-form>

      </div>

      <div class="modal-footer">
        <el-button type="default" @click="closeSelf" style="margin-right: 10px">取消</el-button>
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>

    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5_with_china} from "@/common/Base64MD5";
import {getStaffDTO} from "@/utils/auth";

export default {
  name: 'Add',
  props:[],
  data() {
    return {
      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        plateform:'shop',
        phone:'',
        institutionCode:'',
        institutionName:'',

        name:'',
        deviceId:'',
      },
      rules:{
        deviceId:[
          { required: true, message: '输入设备号', trigger: 'blur' },
        ],
        name:[
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      }
    }
  },
  components:{

  },
  methods: {
    init(){
      this.$refs.addForm.resetFields();
    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }


      this.addForm.institutionCode = getStaffDTO().institutionDTO.institutionCode;
      this.addForm.institutionName = getStaffDTO().institutionDTO.userDTO.name;
      this.addForm.phone = getStaffDTO().institutionDTO.userDTO.phone;

      this.addForm.sign = "";
      this.addForm.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(this.addForm) + "&key="+this.$signKey)


      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"GroupGarea/Add",
        data: this.addForm
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$message({type: 'success', message: '添加成功'});
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          })

    },


  }
}


</script>


